module.exports = {
  tag: 'lucky',
  quality: 0.7,
  loot_bonus: 0.01,
};
